// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.off_limits {
  height: 89vh;
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 5vh;
}
.off_limits::-webkit-scrollbar {
  width: 0.7em;
  height: 0.7em;
}
.off_limits::-webkit-scrollbar-thumb {
  background: #2c53a0;
}
.off_limits::-webkit-scrollbar-track {
  background: #96a9d0;
}
.off_limits {
  scrollbar-face-color: #2c53a0;
  scrollbar-track-color: #96a9d0;
}
@media (max-width: 600px) {
  .off_limits::-webkit-scrollbar {
    width: 0em;
    height: 0em;
  }
  .off_limits::-webkit-scrollbar-thumb {
    background: #fff;
  }
  .off_limits::-webkit-scrollbar-track {
    background: white;
  }
  .off_limits {
    scrollbar-face-color: #fff;
    scrollbar-track-color: white;
  }
}
.off_limits .off_limits_logo {
  font-size: 20rem;
  color: #2c53a0;
}`, "",{"version":3,"sources":["webpack://./src/components/auth/auth.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAEA;EACI,YCWU;EDVV,cAAA;ECyBA,aAAA;EACA,uBDzBc;EC0Bd,mBD1BsB;EC2BtB,sBD3B8B;EC4B9B,QD5BsC;AAG1C;ACmCI;EACI,YDtCgB;ECuChB,aDvCgB;AAMxB;ACoCI;EACI,mBAhDI;ADcZ;ACqCI;EACI,mBAbe;ADtBvB;ACuCI;EACI,6BAzDI;EA0DJ,8BAnBe;ADlBvB;AAfI;ECoCA;IACI,UDpCoB;ICqCpB,WDrCoB;EAmB1B;ECqBE;IACI,gBA1CA;EDuBN;ECsBE;IACI,iBAbe;EDPrB;ECwBE;IACI,0BAnDA;IAoDA,4BAnBe;EDHrB;AACF;AA5BI;EACI,gBAAA;EACA,cCXI;ADyCZ","sourcesContent":["@import \"../../variables.scss\";\n\n.off_limits {\n    height: $main-height;\n    overflow: auto;\n    @include flex(center, center, column, 5vh);\n    @include scrollbars(0.7em, $nitroDark);\n    @media (max-width: $mobile) {\n        @include scrollbars(0em, $white);\n    }\n    .off_limits_logo {\n        font-size: 20rem;\n        color: $nitroDark;\n    }\n}\n","//Colors\n$nitroDark: #2c53a0;\n$nitroLight: #64c4e0;\n$background: #e4ffff;\n$fontColor: #4d4d4d;\n$error: #bb0000;\n$warning: #f29422;\n$white: #fff;\n$black: #000;\n$success: #b6fcc9;\n$green: #357a38;\n\n//Heights\n$nav-height: 10vh;\n$main-height: 89vh;\n$footer-height: 6vh;\n\n//Breakpoints\n$mobile: 600px;\n$tablet: 1000px;\n$desktop: 1300px;\n\n//Layout\n@mixin flex(\n    $justify: \"center\",\n    $align: \"center\",\n    $direction: \"row\",\n    $gap: \"10px\"\n) {\n    display: flex;\n    justify-content: $justify;\n    align-items: $align;\n    flex-direction: $direction;\n    gap: $gap;\n}\n\n//Overflow\n@mixin scrollbars(\n    $size,\n    $foreground-color,\n    $background-color: mix($foreground-color, white, 50%)\n) {\n    // For Google Chrome\n    &::-webkit-scrollbar {\n        width: $size;\n        height: $size;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background: $foreground-color;\n    }\n\n    &::-webkit-scrollbar-track {\n        background: $background-color;\n    }\n\n    // For Internet Explorer\n    & {\n        scrollbar-face-color: $foreground-color;\n        scrollbar-track-color: $background-color;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
